import { getLocationsForPractice, getProvisionedNumbers } from '@/store/utils'
import * as types from '@/store/mutation-types'
import Location from '@/entities/Location'
import WorkflowServiceClient from '@/clients/workflow/WorkflowServiceClient'
import WebsitesWidgetsServiceClient from '@/clients/websites-widgets/WebsitesWidgetsServiceClient'
import { MESSAGE_SEND_STATUS } from '@/constants/message-send-status'
import { trackInDatadog } from '@/utilities/track-error'

export async function getLocationsWithMessaging ({ commit }, practiceUuid) {
  const allLocations = await getLocationsForPractice(practiceUuid)
  const locationUuids = allLocations.map(location => location.locationId)

  if (locationUuids.length === 0) {
    commit(types.SET_LOCATIONS, [])
    return
  }

  const provisionedNumbers = await getProvisionedNumbers(practiceUuid, locationUuids)

  const provisionedLocations = allLocations.reduce((locations, location) => {
    const provisionedNumberContactDetail = provisionedNumbers
      .find(provisionedNumber => provisionedNumber.locationId === location.locationId)
    if (provisionedNumberContactDetail) {
      locations.push(new Location({
        name: location.name,
        provisionedNumber: provisionedNumberContactDetail.provisionedNumber,
        practiceUuid: practiceUuid,
        locationUuid: provisionedNumberContactDetail.locationId,
        inquiryPhone: location.inquiryPhone
      }))
    }
    return locations
  }, [])

  commit(types.SET_LOCATIONS, provisionedLocations)
}

export async function sendMessage ({ commit }, { message, token }) {
  commit(types.SET_MESSAGE_SEND_STATUS, MESSAGE_SEND_STATUS.PENDING)
  const workflowServiceClient = new WorkflowServiceClient()
  return new Promise((resolve, reject) => {
    workflowServiceClient.saveMessageAsSMS(message, token)
      .then((response) => {
        commit(types.SET_MESSAGE_SEND_STATUS, MESSAGE_SEND_STATUS.SUCCESS)
        resolve(response)
      })
      .catch((error) => {
        commit(types.SET_MESSAGE_SEND_STATUS, MESSAGE_SEND_STATUS.FAILED)
        reject(error)
      })
  })
}

/**
 * @param {Function} commit
 * @param {Array} rootGetters
 * @param {String} slug
 * @returns {Array} customWidgetSettings
 */
export async function getCustomWidgetSettings ({ commit }, { practiceUuid, slug }) {
  const websiteWidgetsServiceClient = new WebsitesWidgetsServiceClient(practiceUuid)

  return new Promise((resolve, reject) => {
    websiteWidgetsServiceClient.getCustomWidgetSettings(slug)
      .then(({ data }) => {
        if (data.data.length) {
          commit(types.SET_WIDGET_SETTINGS, data.data)
        }
        resolve(data.data)
      })
      .catch((error) => {
        trackInDatadog('actions/getCustomWidgetSettings', error, { practiceUuid })
        reject(error)
      })
  })
}
